export default "__VITE_ASSET__54ada261__"